import React from "react";
import { ICellRendererParams } from "@ag-grid-community/core";

import RequestStatusBadge from "../../../RequestStatusBadge";

import { PickupRequestListItem } from "../../../../types";

import styles from "./StatusGridCell.module.scss";

interface Props extends ICellRendererParams {
  data: PickupRequestListItem;
}

export const StatusGridCell = ({ data }: Props) => (
  <RequestStatusBadge status={data.statusCode} className={styles.status} />
);

export default StatusGridCell;
